<template>
    <div class="index">
        <a-layout>

          <a-layout-header :style="{ position: 'fixed', width:'100%',zIndex:1000 }" class="contentHeader">
                <ul>
                    <li v-for="(item,i) in navData" :key="i" :class="{active: ind===i}" @click="headerActive(i)">
                    <span >{{item.name}}</span>
                </li>
                </ul>
                <div class="usergroup">
                    <div class="information">
                         <a-badge dot>
                            <div><img src="../../assets/iocn/bell.svg" alt="" style="width: 100%;height: 100%;vertical-align: middle;"></div>
                         </a-badge>
                        <span>消息</span>
                    </div>
                    <div style="display: inline-block;">
                        <a-dropdown>
                            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                                <a-avatar icon="user" style="margin-right:6px;" />Teacher ma<a-icon type="down" />
                            </a>
                            <a-menu slot="overlay" class="dropdown-manu">
                                <a-menu-item>
                                    <a href="javascript:;"><a-icon type="setting" />账户设置</a>
                                </a-menu-item>
                                <a-menu-item>
                                    <a href="javascript:;"><a-icon type="edit" />密码修改</a>
                                </a-menu-item>
                                <a-menu-item>
                                    <a href="javascript:;"><a-icon type="user" />个人中心</a>
                                </a-menu-item>
                                <a-menu-item>
                                    <a href="javascript:;"><router-link class="loginout" to="/login"><a-icon type="poweroff" />退出</router-link></a>
                                </a-menu-item>
                            </a-menu>
                        </a-dropdown>
                    </div>
                </div>
        </a-layout-header>
        </a-layout>
    </div>
</template>
<script>
    import leftMenu from '../../views/Home'
    export default {
        name:'index',
        components: {
            leftMenu //条件--增加逻辑表达式的组件
        },
        props:['widthNumber'],
        data() {
            return {
                ind:0,  //默认激活哪页
                aooo:undefined,
                navData:[
                    {
                        name:'资产管理',key:'1'
                    },
                    {
                        name:'事件管理',key:'2'
                    },
                    {
                        name:'告警管理',key:'3'
                    },
                    {
                        name:'策略管理',key:'4'
                    },
                    {
                        name:'报表管理',key:'5'
                    },
                    {
                        name:'日志范化',key:'6'
                    },
                    {
                        name:'系统管理',key:'7'
                    },
                ]
            };
        },
        methods:{
            //头部菜单点击切换
            headerActive(index){
                this.ind = index;
            }
        }
    };
</script>

<style scoped>
    .contentHeader ul{
        list-style: none;
        text-align: left;
        height: 100%;
        margin-bottom: 0 !important;
        float: left;
    }
    .contentHeader ul li{
        display: inline-block;
        color: rgba(255, 255, 255, 0.8);
        font-size: 1rem;
        padding: 0 16px;
        height: 60px;
        line-height: 60px;
        cursor: pointer;
        text-align: center;
    }
    .contentHeader ul li:hover{
        background-color: #1b212e;
    }
    .contentHeader ul li.active{
        color: #ffffff;
        background-color: #1b212e;
    }
    #components-layout-demo-side .logo {
        height: 60px;
        background-color: #252d3d;
        line-height: 60px;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        position: fixed;
        z-index: 1;
        width: 10.5%;
    }
    #components-layout-demo-side .logo span{
        font-size: 1.42rem;
        color: #ffffff;
    }
    .ant-layout-header{
        line-height: 0;
        padding: 0;
    }
    #components-layout-demo-side .logo .logoName{
        font-size: 20px;
        color: #ffffff;
    }
    #components-layout-demo-side .contentHeader{
        height: 60px;
        padding: 0px;
        background-color: #252d3d;
    }
    .usergroup{
        position:fixed;
        right:22px;
    }
    .information{
        width:63px;
        height: 100%;
        line-height: 60px;
        display: inline-block;
        margin-right: 17px;
        cursor: pointer;
        color: #fff;
        font-size: 1rem;
    }
    .information:hover{
	    background-color: #1b212e;
    }
    .ant-badge div{
        width: 18px;
        height: 18px;
        display: inline-block;
        margin-right: 2px;
    }
    .ant-dropdown-link{
        font-size: 12px;
        color: #fff;
    }
    .ant-dropdown-link .anticon{
        margin-left: 8px;
    }
    .dropdown-manu{
        top: 20px;
        width: 186px;
        margin-right: -18px;
    }
    .dropdown-manu li:first-child{
        border-top: 1px solid transparent;
    }
    .dropdown-manu li{
	    font-size: 1rem;
        padding-left: 20px;
	    border-top: solid 1px #e8eaf2;
    }
    .dropdown-manu li:hover{
	    background-color: #f5f7fd;
    }
    .dropdown-manu li:hover a{
	    color: #3a99fb;
    }
    .dropdown-manu li a .anticon{
        margin-right: 6px;
    }
    .loginout{
        color: rgba(0, 0, 0, 0.65);
    }
</style>